import type {ConversationDispatch} from './reducer';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import classify from 'src/utils/classify';

import {IconButton} from 'src/components/lib/new-button';

import UndoIcon from 'src/images/icons/undo.svg';
import RedoIcon from 'src/images/icons/redo.svg';
import ZoomIn from 'src/images/icons/zoom-in.svg';
import ZoomOut from 'src/images/icons/zoom-out.svg';
import DownloadIcon from 'src/images/icons/download.svg';

import css from './controls.css';


export default function Controls({
  className,
  dispatch,
  historyIndex,
  historySize,
  scale,
  setScale,
  maxScale,
  minScale,
  disabled,
  onImageExport,
}: {
  className?: string;
  dispatch: ConversationDispatch;
  historyIndex: number;
  historySize: number;
  scale: number;
  setScale: (arg1: number) => unknown;
  maxScale: number;
  minScale: number;
  disabled?: unknown;
  onImageExport?: () => unknown;
}) {
  const {t} = useLabelTranslation();
  return (
    <div className={classify(className, css.root)}>
      <IconButton
        size="small"
        disabled={scale <= minScale}
        onClick={() => setScale((Math.round(scale * 10) - 1) / 10)}
      >
        <ZoomOut />
      </IconButton>
      <IconButton
        size="small"
        disabled={scale >= maxScale}
        onClick={() => setScale((Math.round(scale * 10) + 1) / 10)}
      >
        <ZoomIn />
      </IconButton>

      {!disabled && (
        <>
          <IconButton
            size="small"
            onClick={() => dispatch({type: 'UNDO'})}
            disabled={historyIndex === 0}
          >
            <UndoIcon />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => dispatch({type: 'REDO'})}
            disabled={historyIndex >= historySize - 1}
          >
            <RedoIcon />
          </IconButton>
        </>
      )}

      <IconButton
        size="small"
        onClick={onImageExport}
        title={t('Export_as_PNG', 'Export as PNG')}
      >
        <DownloadIcon />
      </IconButton>
    </div>
  );
}
